import { BaseDataService } from '../../core/BaseDataService';
import { DEFAULT_IMAGESERVER_URL } from '../../core/consts';

/**
 * This class provides access to call various ImageServer APIs, excluding images.
 */
export class ImageServerClient extends BaseDataService {
  constructor (httpProvider, baseUrl = DEFAULT_IMAGESERVER_URL) {
    super();
    Object.assign(this, {
      get _httpProvider () {
        return httpProvider;
      },
      get baseUrl () {
        return baseUrl;
      }
    });
  }

  // By default only support "unauthenticated" mode. Auth provider overrides this method in auth mode. Really bad design
  // but I'm not able to contrive a better one.
  getPathTo ({ path, id }) {
    if (!path && id) {
      throw new Error('No authorization provider is installed; image id\'s are not supported.');
    }
    return path;
  }

  getUrlTo ({ path, id }) {
    return `${this.baseUrl}/${this.getPathTo({ path, id })}`;
  }

  getImageData ({ path, id }, options) {
    const securePath = this.getPathTo({ path, id }) + '?' + options;

    return this._httpProvider.request({
      baseURL: this.baseUrl,
      url: securePath,
      headers: {
        'Content-Type': 'image/jpeg'
      }
    });
  }

  async _send ({ path, id, command, data, parseResponseDelegate, method = 'POST' }) {
    const securePath = this.getPathTo({ path, id });
    let requestData = null;
    let url;

    // ImageServer doesn't really care about request method. Inside this library we're using it to differentiate between
    // commands that are prefixed to the path and ones that aren't.
    if (method === 'POST') {
      requestData = command;
      url = securePath;
      if (data) {
        requestData += ' ' + data;
      }
    } else {
      url = `${command}?/${securePath}`;
    }

    const response = await this._httpProvider.request({
      method,
      baseURL: this.baseUrl,
      url,
      headers: {
        'Content-Type': 'text/plain'
      },
      data: requestData
    });

    if (parseResponseDelegate) {
      response.data = await parseResponseDelegate(response.data);
    }

    return response;
  }
}
